module.exports = __webpack_public_path__ + "img/sunderland-logo-icon.a9714215.png";